import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { Roteador } from '@via-folha/api/src/trpc/roteador.js';

/**
 * Cliente tRPC do painel — tipado ponta a ponta a partir do roteador do
 * servidor. Se um procedure mudar de assinatura, o painel para de compilar,
 * que é exatamente o que se quer numa API interna.
 */

const BASE = import.meta.env['VITE_API_URL'] ?? 'http://127.0.0.1:3030';

let tokenSessao: string | null = null;

export function definirToken(token: string | null): void {
  tokenSessao = token;
  if (token) localStorage.setItem('via-folha-token', token);
  else localStorage.removeItem('via-folha-token');
}

export function tokenArmazenado(): string | null {
  return tokenSessao ?? localStorage.getItem('via-folha-token');
}

export const api = createTRPCClient<Roteador>({
  links: [
    httpBatchLink({
      url: `${BASE}/trpc`,
      headers() {
        const token = tokenArmazenado();
        return token ? { authorization: `Bearer ${token}` } : {};
      },
    }),
  ],
});
